export default "__VITE_ASSET__0f72d6d6__"